import { createTheme } from "@mui/material/styles";

export const cta = createTheme({
  palette: {
    primary: {
      main: "#D05353",
    },
    secondary: {
      main: "#333533",
    },
  },
  typography: {
    button: {
      fontFamily: "Lato",
      fontWeight: 600,
      textTransform: "none",
      fontSize: 18,
    },
  },
});

export const twitter = createTheme({
  palette: {
    primary: {
      main: "#1DA1F2",
    },
    secondary: {
      main: "#333533",
    },
  },
  typography: {
    button: {
      fontFamily: "Lato",
      fontWeight: 600,
      textTransform: "none",
      fontSize: 18,
    },
  },
});

export const primary = createTheme({
  palette: {
    primary: {
      main: "#1E1A1A",
    },
    secondary: {
      main: "#fac7c4",
    },
  },
  typography: {
    button: {
      fontFamily: "Lato",
      fontWeight: 500,
      textTransform: "none",
      fontSize: 18,
    },
  },
});
